import React from "react";
import { useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { AudioFile, AudioRecord, ChatAudioRecorderHoc, ChatAudioSender2Hoc, PreviewCloseHoc, PreviewDownloadHoc, ZoomInHoc, ZoomOutHoc, ZoomRestoreHoc } from "../../../../assets/images";
import { downloadMediaFile, formatBytes, getActiveChatMessages } from "../../../../Helpers/Chat/ChatHelper";
import { formatUserIdToJid } from "../../../../Helpers/Chat/User";
import { INITIAL_LOAD_MEDIA_LIMIT, PREVIEW_MEDIA_TYPES } from "../../../../Helpers/Constants";
import IndexedDb from "../../../../Helpers/IndexedDb";
import { getDbInstanceName, getThumbBase64URL, millisToMinutesAndSeconds } from "../../../../Helpers/Utility";
import SDK from "../../../../SDK";
import { getExtension } from "../../Common/FileUploadValidation";
import Spinner from "../../Conversation/Templates/Common/Spinner";
import getFileFromType from "../../ConversationSection/Conversation/Templates/Common/getFileFromType";
import { Player, Shortcut } from "video-react";
import { store } from "../../../../Redux/store";
import { resetMessageData } from "../../../../Redux/feature/messageDataSlice";

const CAPTION_MARGIN = 30;
const WebChatMediaPreview = React.memo((props = {}) => {

    const messageData = useSelector((state) => state.messageData);

    const [webChatMedia, setWebChatMedia] = React.useState({
        mediaList: [],
        previewData: [],
        loadMore: false,
        isPlaying: false,
        palyStatus: true,
        NeedDevelopment: false,
        favouriteMsgs: {},
        starStatusCheck: false,
        allowInitialCall: false,
        seletedMsgId: "",
        initialLoad: true,
        viewAllMedias: true,
        previewLoading: true,
    })
    const {
        mediaList,
        loadMore,
        // NeedDevelopment,
        // starStatusCheck,
        // isPlaying,
        // favouriteMsgs,
        initialLoad,
        previewData,
        allowInitialCall,
        // seletedMsgId,
        previewLoading,
    } = webChatMedia;

    const [initialRender, setInitialRender] = React.useState(false)
    const [selectedItem, setSelectedItem] = React.useState(0)
    const [selectedMediaIndex, setSelectedMediaIndex] = React.useState(0)
    const [previewLoadedVideosIndex, setPreviewLoadedVideosIndex] = React.useState([])
    const [lastTranslateX, setLastTranslateX] = React.useState(false)
    const [tempSelectedItem, setTempSelectedItem] = React.useState(0)

    let localDb = new IndexedDb();
    let Previous = React.useRef(null);
    let Next = React.useRef(null);

    React.useEffect(() => {
        commonForDidMountAndFailedDidMount();
        setTimeout(() => {
            setInitialRender(true)
        }, 500)
        const pauseButton = document.querySelectorAll('[aria-label="Pause"]')
        if (pauseButton.length !== 0) {
            pauseButton[0].click()
        }
        document.addEventListener("keydown", handleOnKeyPress, { passive: true });
        return () => { document.removeEventListener("keydown", handleOnKeyPress, { passive: false }) };
    }, [])

    React.useEffect(() => {
        if (mediaList.length !== 0) {
            allowInitialCall && diplayMedia()
            if (messageData.data.msgType === "recallMessage" ||
                messageData.data.msgType === "carbonRecallMessage" ||
                messageData.data.clearType === "delete_message") {
                diplayMedia("delete");
            }
        }
    }, [mediaList])


    React.useEffect(() => {
        if (messageData.data && (messageData.data.msgType === "recallMessage" ||
            messageData.data.msgType === "carbonRecallMessage" ||
            messageData.data.clearType === "delete_message")) {
            handleDeleteMedia();
        }
    }, [messageData.id])


    React.useEffect(() => {
        mediaList.length !== 0 && !previewLoading && diplayMedia();
    }, [initialRender])

    React.useEffect(() => {
            if (initialRender === true && mediaList.length !== 0 && mediaList[selectedMediaIndex].msgBody?.message_type == 'video') {
                if (!previewLoadedVideosIndex.includes(selectedMediaIndex)) {
                diplayMedia();
            }}
    }, [selectedMediaIndex])

    const handleOnKeyPress = (event) => {
        switch (event.keyCode) {
            case 27:
                props.handleMediaClose();
                break;
            case 37:
                Previous.current && Previous.current.click();
                break;
            case 39:
                Next.current && Next.current.click();
                break;
            default:
                break;
        }
    };

    const getFile = async (fileToken, type, thumbImage, fileKey, fileExtensionSlice) => {
        if (!fileToken) return null;
        if (type === "image") {
            return localDb
                .getImageByKey(fileToken, getDbInstanceName(type), fileKey)
                .then((blob) => {
                    const dbBlob = new Blob([blob], { type: type + "/" + fileExtensionSlice });
                    const blobUrl = window.URL.createObjectURL(dbBlob)
                    return blobUrl
                })
                .catch(() => thumbImage);
        } else {
            const mediaResponse = await SDK.getMediaURL(fileToken, fileKey);
            if (mediaResponse.statusCode === 200) {
                const videoBlob = new Blob([mediaResponse.data.blob], { type: type + "/" + fileExtensionSlice });
                const blobUrl = window.URL.createObjectURL(videoBlob)
                return blobUrl
            } else {
                console.log("error in loading media file");
                return "";
            }
        }
    };

    const getTransformMatrix = (targetThumb) => {
        const style = targetThumb.style.getPropertyValue("transform");
        return new DOMMatrixReadOnly(style);
    };

    const setTransformMatrix = (targetThumb, matrixM41) => {
        targetThumb.style = `transform: translate3d(${Math.abs(matrixM41)}px, 0, 0)`;
        setLastTranslateX(matrixM41)
    };

    const handleStyleChange = (targetThumb) => {
        const { m41: initialM41 } = getTransformMatrix(targetThumb);
        setTransformMatrix(targetThumb, initialM41);
        const mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutationRecord) => {
                const { m41: newM41 } = getTransformMatrix(mutationRecord.target);
                if (lastTranslateX !== newM41 && newM41) {
                    setTransformMatrix(targetThumb, newM41);
                    mutationObserver.disconnect();
                }
                mutationObserver.observe(targetThumb, { attributes: true, attributeFilter: ["style"] });
            });
        });
        mutationObserver.observe(targetThumb, { attributes: true, attributeFilter: ["style"] });
    };

    const initializeMutation = () => {
        let thumbInterval = setInterval(() => {
            const targetThumb = document.querySelector(".thumbs.animated");
            if (targetThumb) {
                handleStyleChange(targetThumb);
                clearInterval(thumbInterval);
                thumbInterval = 0;
            }
        }, 100);
    };

    const commonForDidMountAndFailedDidMount = async () => {
        initializeMutation();
        const chatMediaList = getActiveChatMessages();
        let chatMediaListData = chatMediaList.filter(
            (el) => el && el.msgBody && PREVIEW_MEDIA_TYPES.includes(el.msgBody.message_type) && el.deleteStatus === 0 && el.msgStatus !== 3
            );
        if (chatMediaListData.length) {
            let selectedItemData = chatMediaListData.findIndex((el) => el.msgId === props.selectedMessageData.msgId);
            if (selectedItemData <= INITIAL_LOAD_MEDIA_LIMIT) {
                loadMoreMedia(chatMediaListData);
            } else {
                chatMediaListData.sort((a, b) => (b.timestamp > a.timestamp ? 1 : -1));
                let selectedMediaItem = chatMediaListData.findIndex((el) => el.msgId === props.selectedMessageData.msgId);
                setWebChatMedia({
                    ...webChatMedia,
                    allowInitialCall: true,
                    mediaList: chatMediaListData,
                })
                setTempSelectedItem(selectedMediaItem)
                setSelectedItem(selectedMediaItem)
                setSelectedMediaIndex(selectedItem)
            }
        }
    }

    const handleDeleteMedia = () => {
        const newMediaList = [...mediaList];
        const preViewData = [...previewData];
        const messageIds = messageData.data.msgId.split(",");
        for (const element of messageIds) {
            const msgId = element;
            let deleteItem = mediaList.findIndex((el) => el.msgId === msgId);
            newMediaList.splice(deleteItem, 1);
            preViewData.splice(deleteItem,1);
        }
        /**
         for (let i = 0; i < messageIds.length; i++) {
            const msgId = messageIds[i];
            let deleteItem = mediaList.findIndex((el) => el.msgId === msgId);
            newMediaList.splice(deleteItem, 1);
            preViewData.splice(deleteItem,1);
        }
         */
        newMediaList.length === 0 && props.handleMediaClose()
        setWebChatMedia({
            ...webChatMedia,
            mediaList: newMediaList,
            previewData:preViewData
        })
        setLastTranslateX(false)
        initializeMutation();
    };

    /**
    // React.useEffect(()=>{
    //     initialCall();
    // },[webChatMedia])

    // const initialCall = () => {
    //     if (mediaList.length > 0 && !allowInitialCall) {
    //         // const checkInitalStar = mediaList[selectedItem].favouriteStatus === 1 ? true : false;
    //         setWebChatMedia(
    //         {   ...webChatMedia,
    //             allowInitialCall: true,
    //             // starStatusCheck: checkInitalStar,
    //             seletedMsgId: mediaList[selectedItem].msgId,
    //         })
    //     }
    // };
    */

    const handleGetMedia = async (messageId, mediaDataList) => {
        const { jid: msgFrom, chatType } = props;
        if (chatType === "broadcast") {
            let jid = formatUserIdToJid(msgFrom);
            SDK.getBroadcastChatMedia(jid, messageId);
        } else {
            let jid = formatUserIdToJid(msgFrom, chatType);
            const mediaMsgRes = await SDK.getMediaMessages(jid, messageId);
            if (mediaMsgRes && mediaMsgRes.statusCode === 200 && mediaMsgRes.data) {
                // Filtering Media Duplicates with Message Id
                const msgIds = new Set(mediaDataList.map((d) => d.msgId));
                const newList = [
                    ...mediaDataList,
                    ...mediaMsgRes.data.filter((d) => !msgIds.has(d.msgId) && PREVIEW_MEDIA_TYPES.includes(d.message_type))
                ];
                newList.sort((a, b) => (b.timestamp > a.timestamp ? 1 : -1));
                let selectedDataItem = newList.findIndex((el) => el.msgId === props.selectedMessageData.msgId);
                if (initialLoad) {
                    setSelectedMediaIndex(selectedDataItem)
                    setSelectedItem(selectedDataItem)
                    setTempSelectedItem(selectedDataItem)
                }
                setWebChatMedia({
                    ...webChatMedia,
                    allowInitialCall: true,
                    mediaList: newList, loadMore: false
                });
            }
        }
    };

    const handleDisplayMedia = async () => {
        return Promise.allSettled(
            mediaList.map(async (media, index) => {
                let audioType = media?.msgBody?.media?.audioType;
                let msgObj = media.msgBody ? media.msgBody : media;
                let {
                    message_type,
                    media: {
                        fileName = null,
                        file_url = null,
                        file_key = null,
                        file_size = null,
                        caption = null,
                        thumb_image = null,
                        duration = null,
                        is_uploading = 2,
                        // originalWidth,
                        originalHeight
                    } = {}
                } = msgObj;
                let { msgId } = media;
                let temp;
                if (caption !== null) {
                    temp = document.createElement("div");
                    temp.innerHTML = caption;
                }
                const fileSize = formatBytes(file_size);
                thumb_image = getThumbBase64URL(thumb_image);
                let mediaData = {};
                const fileExtension = getExtension(fileName);
                const placeholder = getFileFromType(null, fileExtension);
                const fileExtensionSlice = fileExtension.split(".")[1]

                switch (message_type) {
                    case "image":
                        const imageSrc = is_uploading === 1 ? file_url : await getFile(file_url, "image", thumb_image, file_key, fileExtensionSlice);
                        if (!imageSrc || imageSrc === "") {
                            break;
                        }
                        mediaData = {
                            class: "type-image",
                            imageURL: imageSrc,
                            fileName: fileName,
                            media: (
                                <>
                                    <div className="imageZoomWrapper">
                                        <TransformWrapper>
                                            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                                                <React.Fragment>
                                                    <div className="tools zoomTools">
                                                        <button onClick={zoomIn}>
                                                            <ZoomInHoc viewBox="0 0 24 24" />

                                                        </button>
                                                        <button onClick={zoomOut}>
                                                            <ZoomOutHoc viewBox="0 0 24 24" />
                                                        </button>
                                                        <button onClick={resetTransform}>
                                                            <ZoomRestoreHoc />
                                                        </button>
                                                    </div>
                                                    <TransformComponent>
                                                        <img src={imageSrc} alt="" />
                                                    </TransformComponent>
                                                </React.Fragment>
                                            )}
                                        </TransformWrapper>
                                    </div>
                                    {caption ? <p className="legend image-caption">{temp.textContent}</p> : ""}
                                </>
                            )
                        };
                        break;

                    case "file":
                        mediaData = {
                            class: "type-image file",
                            imageURL: placeholder,
                            media:
                                fileName && fileSize ? (
                                    <div className="type-thumb-image">
                                        <p className="legend document-name">{`${fileName} , ${fileSize}`}</p>
                                    </div>
                                ) : (
                                    ""
                                )
                        };
                        break;

                    case "audio":
                        const audioSrc = is_uploading === 1 ? file_url : await getFile(file_url, "audio", {}, file_key, fileExtensionSlice);
                        if (!audioSrc || audioSrc === "") {
                            break;
                        }
                        mediaData = {
                            class: "type-media audio",
                            imageURL: audioType !== "recording" ? AudioFile : AudioRecord,
                            media: (
                                <div className="video-wrapper1" duration={millisToMinutesAndSeconds(duration)}>

                                    <div style={{ height: '60%', width: '100%' }}>
                                        <i className={`AudioDetails ${"default"}`}>
                                        {audioType !== "recording" ? <ChatAudioSender2Hoc viewBox="0 0 35 35" /> : <ChatAudioRecorderHoc viewBox="0 0 13.249 19.873" />}
                                            <span className="audioDuration">{millisToMinutesAndSeconds(duration)}</span>
                                        </i>
                                        <Player>
                                            <source src={audioSrc} />
                                            <Shortcut disabled />
                                        </Player>
                                    </div>

                                </div>
                            )
                        };
                        break;

                    case "video":
                        if (initialRender === true && index === tempSelectedItem) {
                        const videoSrc = is_uploading === 1 ? file_url : await getFile(file_url, "video", {}, file_key, fileExtensionSlice);
                        if (!videoSrc || videoSrc === "") {
                            break;
                        }
                        mediaData = {
                            class: "type-media videos",
                            imageURL: thumb_image,
                            media: (
                                <div className="video-wrapper1" id={`video-player-${msgId}`}>
                                    <div style={{ height: '60%', width: '70%' }}>
                                        <Player>
                                            <source src={videoSrc} />
                                            <Shortcut disabled />
                                        </Player>
                                    </div>
                                    {caption ? (
                                        <p
                                            className="legend image-caption"
                                            id={`video-caption-${msgId}`}
                                            style={{ minHeight: "70px", marginTop: `${CAPTION_MARGIN}px` }}
                                        >
                                            {temp.textContent}
                                        </p>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            )
                        };
                        } else {
                            mediaData = {
                                class: "type-media videosThumb",
                                imageURL: thumb_image,
                                media: (
                                    <div className="video-wrapper1" id={`video-player-${msgId}`}>
                                        <img src={thumb_image} alt={thumb_image} style={{ height: originalHeight, width: "1000px" }}
                                            className="previewVideoThumbnail" />
                                        <div style={{ zIndex: 3 }}><Spinner /></div>
                                        {caption ? (
                                            <p
                                                className="legend image-caption"
                                                id={`video-caption-${msgId}`}
                                                style={{ minHeight: "70px", marginTop: `${CAPTION_MARGIN}px` }}
                                            >
                                                {temp.textContent}
                                            </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                )
                            };
                        }
                        break;

                    default:
                        mediaData = {};
                        break;
                }
                return (
                    <div key={msgId} className={mediaData.class} id={msgId}>
                        <img src={mediaData.imageURL} alt={mediaData.fileName} />
                        {mediaData.media}
                    </div>
                );
            })
        );
    };

    const diplayMedia = async (type = "") => {
        let media = [];
        let previewDatas = [...previewData];
        let dataPreview = []
        handleDisplayMedia().then((results) => results.forEach((result, index) => {
            if (result.status === "fulfilled") {
                if (initialRender === false) {
                media.push(result.value);
                }
                else {
                    if (tempSelectedItem === index && previewDatas[index]?.props?.className == 'type-media videosThumb') {
                        previewDatas[index] = result.value
                        media = [...previewDatas]
                        setPreviewLoadedVideosIndex([...previewLoadedVideosIndex, index])
                    } else {
                        if(mediaList.length !== previewData.length){
                            dataPreview.push(result.value)
                            const data = previewDatas.map((ele)=>{
                                return ele.key
                            })
                            const constructedMedia = dataPreview.filter(ele=>!data.includes(ele.key))
                            media = [...previewDatas,...constructedMedia]
                        }else{
                            media = [...previewDatas]
                        }}
                }
            }
        })).then(() => {
            setWebChatMedia({
                ...webChatMedia,
                previewData: media,
                allowInitialCall: false,
                initialLoad: false,
                previewLoading: false,
            });
            setSelectedItem((type === "delete" && tempSelectedItem !== 0 ? tempSelectedItem - 1 : tempSelectedItem))
            store.dispatch(resetMessageData())
        })
    };

    const handlePrev = (onClickHandler, hasPrev) => {
        return (
            hasPrev && (
                <button
                    type="button"
                    onClick={onClickHandler}
                    title="Previous"
                    ref={Previous}
                    aria-label="previous slide / item"
                    className="control-arrow control-prev"
                ></button>
            )
        );
    };

    const handleNext = (onClickHandler, hasNext) => {
        return (
            hasNext && (
                <button
                    type="button"
                    onClick={onClickHandler}
                    ref={Next}
                    title="Next"
                    aria-label="next slide / item"
                    className="control-arrow control-next"
                ></button>
            )
        );
    };

    const loadMoreMedia = (mediaData) => {
        let mediaListData = mediaData || webChatMedia.mediaList
        let newMediaList = [...mediaListData];
        let lastMsgId = newMediaList[newMediaList.length - 1]?.msgId;
        lastMsgId && handleGetMedia(lastMsgId, newMediaList);
    };

    const imageOnLoad = (e) => {
        e.target.classList.remove("image-load");
        e.target.style.display = "block";
    };

    const customRenderThumb = (children) =>
        children.map((item) => {
            console.log("item",item)
            const url = item.props?.children[0]?.props?.src;
            const duration = item.props?.children[1]?.props?.duration;
            const videoIcon = item.props?.className === "type-media videosThumb" || item.props?.className === "type-media videos" ? "video-icon" : "";
            const FileIcon = item.props?.className === "type-image file" ? "File" : "";
            return (
                <div key={item.key} className={`thumb-img ${videoIcon || FileIcon} img-load`}>
                    <img
                        src={url}
                        key={`${item.key}-Img`}
                        alt=""
                        onLoad={imageOnLoad}
                        className="image-load"
                        style={{ display: "none" }}
                    />
                    <Spinner />

                    {duration && (
                        <p className="audio-duration" key={`${item.key}-Duration`}>
                            {duration}
                        </p>
                    )}
                </div>
            );
        })

    const downloadFile = () => {
        if (tempSelectedItem > -1 && mediaList.length > 0) {
            const selectedMediaData = mediaList[tempSelectedItem];
            if (selectedMediaData && Object.keys(selectedMediaData).length > 0) {
                const { msgBody: { media: { file_url, fileName: file_name, file_key } = {}, message_type = "" } = {} } =
                    selectedMediaData;
                const fileName = message_type === "file" ? file_name : "";
                downloadMediaFile(file_url, message_type, fileName, file_key);
            }
        }
    };

    const handleMediaOnChange = (index, item) => {
        const dataMsgIdValue = item?.props?.id || "";
        const removeLastIndexValue = dataMsgIdValue;
        setInitialRender(true)
        setTempSelectedItem(index)
        setSelectedMediaIndex(index)

        if (removeLastIndexValue) {
            const checkInitalStar = mediaList.some((ele) => ele.msgId === removeLastIndexValue && ele.favouriteStatus);
            setWebChatMedia({
                ...webChatMedia,
                starStatusCheck: checkInitalStar, seletedMsgId: removeLastIndexValue
            });
        }
        // Load Next Pagination on Media Slide/Selection
        // And Also if its has Load More i.e. If the Previous "Load More Media" has Data
        if (index >= mediaList.length - 1 && !loadMore) {
            setWebChatMedia({
                ...webChatMedia,
                allowInitialCall: true,
                loadMore: true
            });
            loadMoreMedia();
        }
        const elems = document && document.querySelectorAll && document.querySelectorAll(".AudioDetails");
        [].forEach.call(elems, function (el) {
            el.classList.add("default");
            el.classList.remove("playAudio");
        });
        document
            .getElementById("imagePreviewContainer")
            .querySelectorAll("video, audio")
            .forEach((element) => {
                if (element) {
                    let dataMsgId = element.getAttribute("data-msgid");
                    if (dataMsgId && dataMsgId + index === item.props.id) {
                        element.play();
                    } else {
                        element.currentTime = 0;
                        element.pause();
                    }
                }
            });
    };

    const initialThumbnailImage = getThumbBase64URL(mediaList[selectedItem]?.msgBody?.media?.thumb_image) || "";

    return (
        <React.Suspense
            fallback={<div>Loading...</div>}>
            <React.Fragment>
                <div>
                    <div
                        className="imagePreviewContainer imagePreviewWrapper"
                        id="imagePreviewContainer"
                    >
                        {previewLoading && (
                            <div className="previewContainer">
                                {mediaList.length > 0 && <img src={initialThumbnailImage} alt={initialThumbnailImage} className="previewContainerImg" />}
                                <div style={{ zIndex: 3 }}><Spinner /></div>
                            </div>
                        )}
                        <div className="preview-options">
                            <ul>
                                <li>
                                    <i className="" title="Download" onClick={downloadFile}>
                                        <PreviewDownloadHoc viewBox="0 0 21.87 20.308" />
                                    </i>
                                </li>

                                {/** {isStarMessageEnabled &&
                            <li
                                onClick={() => this.handleStarMessage()}>
                                <i
                                className="icon-star"
                                title={starStatusCheck === true ? "Star" : "Unstar"}
                                >
                                <PreviewStar fill="#fff"
                                    id={"starFillId"}
                                    style={{ display: starStatusCheck ? "none" : "inline-block" }}
                                />
                                <PreviewStarActive
                                    id={"starFillId"}
                                    style={{ display: starStatusCheck ? "inline-block" : "none" }}
                                />
                                </i>
                            </li>
                            } 
         */}
                                {/** {this.state.NeedDevelopment && (
                            <>
                                <li>
                                <i className="" title="Find in Chat">
                                    <PreviewChat />
                                </i>
                                </li>
                                <li>
                                <i className="" title="Forward">
                                    <PreviewForward />
                                </i>
                                </li>
                            </>
                            )} */}
                                <li>
                                    <i className="preview-close" title="Close" onClick={props.handleMediaClose}>
                                        <PreviewCloseHoc viewBox="0 0 20.333 20.2" />
                                    </i>
                                </li>
                            </ul>
                        </div>
                        {previewData.length && (
                            <Carousel
                                key={mediaList[0].msgId}
                                renderArrowPrev={handleNext} // For Handling Right to Left Slide, We are Revering the Logic
                                renderArrowNext={handlePrev}
                                selectedItem={selectedItem}
                                onChange={handleMediaOnChange}
                                onClickThumb={handleMediaOnChange}
                                renderThumbs={customRenderThumb}
                                transitionTime="10"
                                thumbWidth="120"
                                swipeable={false}
                            >
                                {previewData}
                            </Carousel>
                        )}
                    </div>
                </div>
            </React.Fragment>
        </React.Suspense>
    );

})
export default WebChatMediaPreview